import React from 'react';
import { Button as ChakraButtonBase } from '@chakra-ui/react';

/**
 * Chakra UI版のButtonコンポーネント
 * 既存のTailwind版と並行して使用可能
 */
const ChakraButton = ({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  disabled = false,
  leftIcon,
  rightIcon,
  isLoading = false,
  loadingText,
  ...props
}) => {
  return (
    <ChakraButtonBase
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      isLoading={isLoading}
      loadingText={loadingText}
      {...props}
    >
      {children}
    </ChakraButtonBase>
  );
};

export default ChakraButton;